import styled from 'styled-components'
import { colors } from '../colors'

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${colors.Map.modal.overlay};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  pointer-events: auto;
`

export const ModalContent = styled.div`
  background-color: ${colors.Map.modal.darkBackground};
  padding: 16px 16px 24px 16px;
  border-radius: 24px;
  max-width: 328px;
  pointer-events: auto;
  position: relative;
  z-index: 1001;
`
